import { ADMIN_BASE_PATH } from '@neyara/shared';
import { createBrowserRouter, Navigate } from 'react-router';
import { StoreLayout } from './components/store-layout';
import { CatalogPage } from './pages/catalog';
import { HomePage } from './pages/home';
import { NotFoundPage } from './pages/not-found';
import { SareePage } from './pages/saree';

// The admin panel (forms, validation, uploads) loads only when someone opens it.
export const router = createBrowserRouter([
  {
    element: <StoreLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'sarees', element: <CatalogPage /> },
      { path: 'sarees/:slug', element: <SareePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: `${ADMIN_BASE_PATH}/login`,
    lazy: async () => ({ Component: (await import('./admin/login')).LoginPage }),
  },
  {
    path: ADMIN_BASE_PATH,
    lazy: async () => ({ Component: (await import('./admin/admin-layout')).AdminLayout }),
    children: [
      { index: true, element: <Navigate to="sarees" replace /> },
      { path: 'sarees', lazy: async () => ({ Component: (await import('./admin/sarees-list')).SareesListPage }) },
      { path: 'sarees/new', lazy: async () => ({ Component: (await import('./admin/saree-form')).SareeEditPage }) },
      { path: 'sarees/:id', lazy: async () => ({ Component: (await import('./admin/saree-form')).SareeEditPage }) },
      { path: 'categories', lazy: async () => ({ Component: (await import('./admin/categories')).CategoriesPage }) },
      { path: 'account', lazy: async () => ({ Component: (await import('./admin/account')).AccountPage }) },
    ],
  },
]);
